// extracted by mini-css-extract-plugin
module.exports = {"brands-slider":"BrandsSlider_brands-slider__0dSSv","brand-item":"BrandsSlider_brand-item__qzJvM"};